export enum TrackingActions {
  // Campaign Details
  CAMPAIGN_DETAILS_POSTBUY_CLICK = 'campaign details | postbuy | click',
}
